<template>
  <el-dialog title="选择优惠券" class="select-goods-box" :visible="couponsVisible" @close="closeDialog" width="740px">
    <template>
      <div style="margin: 15px auto;">
        <el-input type="text" v-model="params.keyword" placeholder="请输入优惠券名称" clearable>
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
      </div>
      <el-transfer
        v-loading="loading"
        v-model="selectedCoupons"
        :titles="['优惠券列表', '已选中']"
        :button-texts="['移除选择', '添加选择']"
        @change="couponsSelector"
        :data="couponList">
        <div class="transfer-footer" slot="left-footer">
          <el-pagination v-if="total_count > params.page_size"
            small
            layout="prev, pager, next"
            @current-change="pageChange"
            :total="total_count"
            :page-size="params.page_size" >
          </el-pagination>
        </div>
      </el-transfer>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="couponsComfirm">确 定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import { getCardList } from '@/api/cardticket'

  export default {
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      visible (val) {
        if (val) {
          this.couponsVisible = val
          this.getCouponList()
        }
      }
    },
    data () {
      return {
        couponsVisible: false,
        loading: false,
        params: {
          page_no: 1,
          page_size: 10
        },
        total_count: 0,
        couponList: [],
        selectedCoupons: [],
        couponsListSelect:[],
      }
    },
    methods: {
      //选择商品分页
      pageChange (val) {
        this.params.page_no = val
         this.couponsListSelect = []
         this.couponList.forEach(row => {
           // 如果选中
           let index = this.selectedCoupons.indexOf(row.key)
           if (index != -1) {
             this.couponsListSelect.push(row)
           }
         })
        this.getCouponList()
      },
      //选择商品触发事件
      couponsSelector (value, direction, movedKeys) {
        if(value.length > 10) {
          this.$message({
            message: '最多选择10张优惠券',
            type: 'error',
            duration: 5 * 1000
          })
          this.selectedCoupons.splice(10)
        }
      },
      //选择商品确认
      couponsComfirm () {
        let values = []
        if(this.selectedCoupons.length > 0) {
          this.couponList.forEach(item => {
            this.selectedCoupons.forEach(key => {
              if (item.key == key) {
                let obj = {
                  imgUrl: item.imgUrl,
                  title: item.label,
                  id: item.key,
                  desc: item.desc,
                  amount: item.amount,
                  type: item.type
                }
                values.push(obj)
              }
            })
          })
        } else {
          this.$message({
            message: '请选择优惠券',
            type: 'error'
          });
          return
        }
        this.selectedCoupons = []
        this.couponsVisible = false
        this.$emit('pickCoupon', values)
      },
      search(){
        this.params.title=this.params.keyword;
        this.page_no=1;
        this.getCouponList();
      },
      getCouponList () {
        this.loading = true
        getCardList(this.params).then(res => {
          let list = []
          res.data.data.list.forEach(item => {
            let index = -1
            if (this.selectedCoupons) {
              index = this.selectedCoupons.indexOf(item.card_id)
            }
            if (index === -1) {
              list.push({
                type: item.card_type,
                key: item.card_id,
                label: item.title,
                imgUrl: '',
                desc: item.description,
                amount: item.card_type === 'discount' ? (100 - item.discount)/10 : item.reduce_cost/100
              })
            }
          })
          if (this.couponsListSelect) {
            this.couponList = list.concat(this.couponsListSelect)
          } else {
            this.couponList = list
          }

          this.total_count = res.data.data.pagers.total
          this.loading = false
        })
        .catch( error => {
          this.loading = false
        })
      },
      getCoupons() {
        getEffectiveCardList(this.couponsParams).then(response => {
          let list = []
          response.data.data.list.forEach(row => {
            let index = -1
            if (this.addCouponsItems) {
              index = this.addCouponsItems.indexOf(row.card_id)
            }
            // 如果未选中
            if (index === -1) {
              list.push({
                key: row.card_id,
                label: row.title + '(' + row.quantity + ')'
              })
            }
          })
          if (this.couponsListSelect) {
            this.couponsList = list.concat(this.couponsListSelect)
          } else {
            this.couponsList = list
          }
          this.coupons_total_count = response.data.data.total_count
        })
      },
      closeDialog () {
        this.couponsVisible = false
        this.$emit('closeDialog', 'coupon')
      }
    },
    mounted () {
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// index.vue?a77c2710